export default __webpack_public_path__ + "static/media/unknown.96445c23.jpg";